import React from 'react';
import Selector from '../util/Selector';

const EquipmentSelector = ({
  equipment,
  selected,
  onValueChange,
  disabled,
  filter = () => true,
  displayNameRender = null,
}) => (
  <Selector
    options={equipment.filter(filter).map((e) => ({
      id: e.id,
      key: `${e.id}`,
      display: displayNameRender == null ? `${e.name}` : displayNameRender(e),
    }))}
    selected={selected ? `${selected}` : ''}
    onChange={(e) => onValueChange(e.target.value)}
    disabled={disabled}
  />
);

export default EquipmentSelector;
